module.exports = __webpack_public_path__ + "static/media/step-forward.47903f60.svg";